/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['../constants'], function(constants) {
	'use strict';
	class Rave2bundleradialbar {
		get config(){
			return {
				'type':'Dial',
				'disablePan':true,
				'isRecommendable':false,
				'propertiesToSetBeforeData': [
					'widget.data.truncate'
				],
				'listenForPropChanges': [
					'widget.legend.size'
				],
				'slots':{
					'categories':{
						'sort':'asc',
						'icon':'radialbar_category'
					},
					'values':{
						'icon':'values'
					},
					'maxValue':{
						'icon':'values'
					},
					'color':{
						'icon':'colorBy',
						'sort':'asc',
						'mldTitleProperty': 'color.title',
						'tags': ['canUseToColor']
					},
					'repeatHorizontal':{
						'icon':'multiplier_h',
						'sort':'asc'
					},
					'repeatVertical':{
						'icon':'multiplier_v',
						'sort':'asc'
					}
				},
				'propertyPrefixes': {
					'dataPoint': 'valueLabels',
					'color': 'widget.legend',
					'legend':'widget.legend',
					'row': 'widget.repeatVertical.labels',
					'column': 'widget.repeatHorizontal.labels'
				},
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont']
				},
				'properties':{
					'color.title': {
						'multilingual': true
					},
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'format.compact':{
						'active':false
					},
					'legendPosition':{
						'active':false
					},
					'legend.display':{
						'active':false
					},
					'effect.duration': {
						'active': false,
						'defaultValue': constants.LONG_EFFECT_DURATION
					},
					'dial.startAngle': {
						'active': false
					},
					'dial.maxValue': {
						'active': false
					},
					'dial.border.width':{
						'active': false
					},
					'dial.padding':{
						'active': false
					},
					'dial.width':{
						'active': false
					},
					'center.background.radius':{
						'active':false
					},
					'center.padding.radius':{
						'active':false
					},
					'center.padding':{
						'active':false
					},
					'dial.minFontSize':{
						'active':false
					},
					'center.radius': {
						active: false
					},
					'valueLabels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'valueLabelsTitle.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.size': {
						active: false
					},
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					},
					'widget.repeatHorizontal.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.repeatVertical.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					}
				},
				'queryHints':{
					'multiEdgeSort':true
				},
				config:{
					'include':[
						'widget.data.truncate',
						'widget.iterator',
						'widget.legend.display',
						'widget.legend.position',
						'backgroundColor',
						'widget.legend.backgroundColor',
						'effect.duration',
						'valueLabels.format',
						'valueLabels.font',
						'valueLabels.color',
						'valueLabelsTitle.font',
						'valueLabelsTitle.color',
						'valueLabels.contrast.color',
						'backRing.color',
						'dial.border.color',
						'dial.border.width',
						'dial.padding',
						'dial.padding.color',
						'dial.width',
						'dial.roundedEnds',
						'dial.startAngle',
						'dial.maxValue',
						'center.background.radius',
						'center.padding.radius',
						'center.color',
						'center.radius',
						'dial.minFontSize',
						'dial.propotionalwidths',
						'dial.showAsPercentage',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.font',
						'widget.legend.titleColor',
						'widget.legend.titleFont',
						'widget.legend.swatch.symbol.default',
						'colors.color.cat',
						'colors.color.cont',
						'widget.legend.size',
						'widget.repeatHorizontal.labels.color',
						'widget.repeatVertical.labels.color',
						'widget.repeatHorizontal.labels.font',
						'widget.repeatVertical.labels.font',
						'widget.legend.titleVisible',
						'color.title',
						'optimizeSize',
						'labels.contrast.color'
					],
					'exclude':[
					]
				},
				'usages':[
					'Comparison',
					'Trend'
				],
				'supportsMaintainAxisScale': true
			};
		}

	}
	return Rave2bundleradialbar;
});
